<template>
    <div class="absolute bottom-0 w-full h-px -mb-px bg-white border-t border-blue-100">
        <div v-for="index in indices" :key="index.indexId">
            <ul>
                <li v-for="hit in index.hits" :key="hit.objectID">
                    <a
                        :href="hit.url"
                        class="flex flex-col justify-center px-6 py-3 bg-white border-b border-blue-100 md:py-4 small"
                    >
                        <p class="font-bold text-blue-500 truncate">{{ hit.title }}</p>
                        <p class="font-normal text-blue-300 truncate">{{ hit.description }}</p>
                    </a>
                </li>
            </ul>
            <div class="flex pl-6 text-xs bg-blue-500 md:text-base">
                <div class="flex items-center flex-grow py-6 border-r border-blue-300">
                    <a
                        v-if="index.hits.length > 0"
                        :href="'/search?query=' + currentRefinement"
                        class="text-blue-300 small cursor-pointer"
                    >
                        View all {{ index.results.nbHits }} Results
                    </a>
                    <p v-else class="text-blue-300 small">
                        No Results
                    </p>
                </div>
                <a
                    v-if="index.hits.length > 0"
                    class="flex items-center justify-center flex-shrink-0 w-16"
                    :href="'/search?query=' + currentRefinement"
                    aria-label="Submit search query"
                >
                    <svg
                        fill="#fff"
                        class="w-4 h-4"
                        viewBox="0 0 20 20"
                        role="img"
                        focusable="false"
                        aria-label=""
                    >
                        <path
                            d="M12.95 10.707l0.707-0.707-5.657-5.657-1.414 1.414 4.242 4.243-4.242 4.243 1.414 1.414 4.95-4.95z"
                        ></path>
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['indices', 'currentRefinement']
};
</script>
